import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const SippIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
     width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
    <path fill='none' d="M10.5079 2.78462C10.2079 2.55129 9.79125 2.55129 9.49125 2.78462C7.90792 3.99295 3.23291 7.93462 3.25791 12.5263C3.25791 16.243 6.28292 19.2763 10.0079 19.2763C13.7329 19.2763 16.7579 16.2513 16.7579 12.5346C16.7662 8.00962 12.0829 4.00129 10.5079 2.78462Z" stroke="#007ABD" strokeWidth="1.25" strokeMiterlimit="10"/>
    </SvgIcon>
  )
}